import { render, staticRenderFns } from "./bookdetail.vue?vue&type=template&id=4abe90fc&scoped=true"
import script from "./bookdetail.vue?vue&type=script&lang=js"
export * from "./bookdetail.vue?vue&type=script&lang=js"
import style0 from "./bookdetail.vue?vue&type=style&index=0&id=4abe90fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abe90fc",
  null
  
)

export default component.exports